export function isArray(obj) {
  return Array.isArray(obj);
}
